type TestResults = {
    [key: string]: string | number;
};

type Status = {
    [key: string]: string;
};

export enum CONCLUSION_STATEMENT {
    ACCEPT = 'Accept',
    REJECT = 'Reject',
    REVIEW = 'Review',
    UPDATE_SCORE_BY = 'Update score by',
    ADD_TO_LIST = 'Add Parameter [] to List',
    SET_FLAGS = 'Set Flags'
}

export const STATUS: Status = {
    'In Progress': 'In Progress',
    CANCELLED: 'Cancelled',
    FINISHED: 'Finished',
    Failed: 'Failed'
};

export const ICON: Status = {
    'In Progress': 'in-progress',
    CANCELLED: 'small-warning',
    FINISHED: 'small-success',
    Failed: 'small-error'
};

export const RT_HEADERS: TestResults = {
    startDt: 'Start Date',
    endDt: 'End Date',
    duration: 'Date Duration',
    createdAt: 'Created On',
    status: 'Status'
};
